export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/8fdd43c4cd336df9f1b1bcbad6db376f.png";